<template>
  <div class='p-field p-mt-5'>

      <label>Filming Requirements</label>
      <!--      <Button label="Need help?" @click="showHelpModal" class="p-button-link" />-->

    <!--    <ScriptsHelpModal v-model:visible="helpModalVisible" />-->
    <div class="p-field-note on-top">
      <i class="pi pi-info-circle"></i>
       Need creators to shoot the content in a specific location or wearing anything in particular? Add it in here.
    </div>



    <div class='requirements p-mt-3' ref='requirementWrapper'>

      <template v-if='requirements.length'>
        <draggable
          v-model='requirements'
          handle='.requirement-drag'
          @start='onDragStart'
          @end='onDragEnd'
          item-key='id'>
          <template #item='{element: requirement, index}'>
            <div>
              <Requirement
                :requirement='requirements[index]'
                :index="index"
                :hide-new-button='isDragStarted'
                @delete='onRequirementDelete'
              />

              <button class='add-new-requirement' :class='{hovered: canShowFirstAddButton && index === 0}'>
                <div class='tooltip' v-if='index === 0 && canShowTooltip'>
                  <div class='tooltip-title'>Add another requirement</div>
                  <div class='tooltip-text'>Hover the area between the blocks to add a new requirement.</div>
                  <Button label='Got It!' class='p-button-sm' @click.stop='hideTooltip' />
                </div>

                <span class='add-new-requirement-content' @click='addNewRequirement(index)' v-if='canAddMore'>
                  <span class='add-new-requirement-icon'>
                    <i class='pi pi-plus'></i>
                  </span>
                </span>
              </button>
            </div>
          </template>
        </draggable>
      </template>

      <template v-else>
        <div>
          <button class='add-new-requirement' :class='{hovered: true}'>
            <span class='add-new-requirement-content' @click='addNewRequirement(-1)'>
                  <span class='add-new-requirement-icon'>
                    <i class='pi pi-plus'></i>
                  </span>
                </span>
          </button>
        </div>
      </template>

    </div>
  </div>
</template>

<script setup>
import draggable from 'vuedraggable'
import { computed, ref, toRef, watch } from 'vue';
import Requirement from './Requirement';
import NoData from '../../NoData';

const emit = defineEmits(['update:campaign']);
const props = defineProps({
  campaign: { type: Object, required: true },
});

const maxRequirements = 10;
const helpModalVisible = ref(false);
const canShowTooltip = ref(true);
const canShowFirstAddButton = ref(true);
const isDragStarted = ref(false);
const requirements = toRef(props.campaign, 'requirements');
const canAddMore = ref(true);

const onDragStart = () => isDragStarted.value = true;
const onDragEnd = () => {
  isDragStarted.value = false;
  requirements.value.forEach((Requirement, index) => Requirement.position = index);
};

const addNewRequirement = index => {
  const position = index + 1;
  const Requirement = {
    position: position,
    requirement: '',
    description: '',
  };

  requirements.value.forEach(Requirement => {
    if (Requirement.position >= position) {
      Requirement.position++;
    }
  });

  requirements.value.splice(position, 0, Requirement);
  requirements.value = requirements.value.map((Requirement, index) => ({
    ...Requirement,
    position: index,
  }));

  canAddMore.value = canAddRequirement();
};

const canAddRequirement = () => requirements.value.length < maxRequirements;

// watch(() => requirements.value, () => {
//   canNextStep.value = requirements.value.length && requirements.value.every(requirementIsFullFilled);
// }, { immediate: true, deep: true });

const onNextStep = () => emit('onNext');

const onRequirementDelete = index => {
  requirements.value.splice(index, 1);
  canAddMore.value = canAddRequirement();
}
const hideTooltip = () => {
  canShowTooltip.value = false;
  canShowFirstAddButton.value = false;
};
const showHelpModal = () => helpModalVisible.value = true;

</script>

<style lang='scss' scoped>
@import "../../../assets/sass/theme_variables";

.requirement-wrapper {
  width: toRem(548);
  margin: 0 auto;
  padding-bottom: 1rem;
}

.requirement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: toRem(16);

  h4 {
    margin-bottom: 0;
  }

  .p-button {
    font-weight: 600;
    text-decoration: underline;

    &:hover, .p-button-label {
      text-decoration: none;
    }
  }
}

.text {
  margin-bottom: toRem(24);
}

.add-new-requirement {
  height: toRem(16);
  position: relative;
  width: 100%;
  padding-top: toRem(16);
  border: none;
  outline: none;
  color: $bgBlocks;
  background: none;
  transition: height 0.3s, padding-top 0.3s, padding-bottom 0.3s;

  &:hover, &.hovered {
    height: toRem(64);
    padding-bottom: toRem(16);

    .add-new-requirement-content {
      height: 32px;
      background-color: rgba(15, 139, 253, 0.05);
      border-color: $primaryColor;
    }

    .add-new-requirement-icon {
      display: flex;
    }

  }

  .add-new-requirement-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: toRem(10);
    position: absolute;
    width: toRem(24);
    height: toRem(24);
    border-radius: 50%;
    left: 50%;
    top: 3px;
    transform: translateX(-50%);
    background: $textColor;
  }

  .tooltip {
    left: 100%;
    top: 50%;
    transform: translate(18px, -50%);
  }
}

.add-new-requirement-content {
  cursor: pointer;
  height: 0;
  display: block;
  position: relative;
  border: 1px solid transparent;
  border-radius: $borderRadius;
  transition: border-color 0.3s, background-color 0.3s, height 0.3s;
  overflow: hidden;

  &:before, &:after {
    position: absolute;
    top: 14px;
    height: 2px;
    background: $textColor;
    border-radius: 2px;
    content: '';
  }

  &:before {
    left: toRem(12);
    right: 50%;
    margin-right: 16px;
  }

  &:after {
    right: toRem(12);
    left: 50%;
    margin-left: 16px;
  }
}

.tooltip {
  min-width: 260px;
  text-align: left;
  position: absolute;
  padding: toRem(16);
  background: $textColor;
  color: $bgBlocks;
  border-radius: 8px;
  z-index: 10;
  font-size: toRem(16);

  &:before {
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid $textColor;
    border-bottom: 10px solid transparent;
    transform: translate(-100%, -50%);
    content: '';
  }

  .p-button {
    margin-top: toRem(16);
  }
}

.tooltip-title {
  font-weight: bold;
  color: $bgBlocks;
}

.tooltip-text {
  opacity: 0.8;
  line-height: 140%;
}
</style>
